import { BreakpointObserver } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DiscoverFacade } from '@zero/discover/domain';
import { commonRoutes } from 'constants/web-app-constants';
import { map } from 'rxjs';

@Component({
  selector: 'home-multi-order-strategies-slider',
  imports: [AsyncPipe, RouterLink, TranslocoPipe],
  templateUrl: './multi-order-strategies-slider.component.html',
  styleUrl: './multi-order-strategies-slider.component.scss',
})
export class MultiOrderStrategiesSliderComponent implements OnInit {
  public slideRange = [];

  public readonly discoverFacade = inject(DiscoverFacade);
  readonly #breakpointObserver = inject(BreakpointObserver);
  readonly #destroyRef = inject(DestroyRef);
  public readonly url = commonRoutes.postlogin.multi_order_strategies;

  public strategies$ = this.discoverFacade.multiOrderStrategies$.pipe(
    map((strategies) => [
      {
        id: '',
        title: 'my-home.multi-order-strategies-landing-page.description-card.headline',
        description: 'my-home.multi-order-strategies-landing-page.description-card.text',
        link: 'my-home.multi-order-strategies-landing-page.description-card.link',
      },
      ...strategies,
    ]),
  );

  public ngOnInit(): void {
    this.discoverFacade.loadMultiOrderStrategies();

    this.#breakpointObserver
      .observe('(max-width: 767px)')
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((state) => (this.slideRange = [0, (state.matches ? 1 : 4) - 1]));
  }

  public prev() {
    this.slideRange[0] -= 1;
    this.slideRange[1] -= 1;
  }

  public next() {
    this.slideRange[0] += 1;
    this.slideRange[1] += 1;
  }
}
